import { graphql } from 'react-apollo'

#
# Mutations
#

import updatePersonalDetails from '/mutations/users/update_personal_details.gql'

export withUpdatePersonalDetails = graphql updatePersonalDetails,
  props: ({ mutate })->
    updatePersonalDetails: (id, details)->
      {data: {user_update_personal_details: {user, errors}}} = \
      await mutate variables: {id, details...}
      {user, errors}
